import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    AngebotsListe,
    AngebotsVersionsListe,
    AngebotsListeZuordnungAntwortDto,
    ZuordnungZeile,
} from 'src/app/shared/model';

export abstract class AngebotsListenService {
    abstract einlesen(
        file: File,
        angebotsListenId: string,
        listenName: string,
        gueltigVon: string,
        gueltigBis: string
    ): Observable<any>;

    abstract getAngebotsListenVonIndustriepartner(): Observable<any>;

    abstract getVersionsnummerVonAngebotsliste(id: string): Observable<number>;

    abstract zuordnen(
        angebotsListenId: string,
        apothekenIds: string[],
        gruppenIds: string[],
        kooperationIds: string[],
        exlusiveList: boolean,
    ): Observable<any>;

    abstract zuordnenDefaultListe(angebotsListenId: string);

    abstract getAngebotVersionsListenInZeitraum(
        von: Date,
        bis: Date
    ): Observable<AngebotsVersionsListe[]>;

    abstract getZuordnungenForAngebotListe(
        listenId: string
    ): Observable<AngebotsListeZuordnungAntwortDto>;

    abstract getZuordnungenZuAngebotVersionsListenIds(
        angebotVersionsListenIds: string[]
    ): Observable<ZuordnungZeile[]>;
}
